import {frontend} from 'pageflow-scrolled/frontend';

import {LogoBar} from './LogoBar';

frontend.contentElementTypes.register('logoBar', {
  component: LogoBar
});
